<div class="modal-header" *transloco="let t">
  <h4 class="modal-title">{{ t('transfer/changeWorkplaceTitle') }}</h4>
  <button type="button" class="btn-close-icon" aria-label="Close" (click)="cancel()"><i class="material-symbols-rounded">close</i></button>
</div>

<div class="modal-body" *transloco="let t">
  <div class="form-group mb-3">
    <label class="form-label"> {{ t('transfer/moveChildrenToWorkplace') }}<span class="text-primary"> *</span> </label>
    <ng-select
      class="form-control"
      [items]="workplaces"
      bindLabel="name"
      bindValue="uuid"
      [clearable]="false"
      [placeholder]="t('transfer/selectWorkplace')"
      [formControl]="workplaceControl"
      appendTo="body"
    ></ng-select>
  </div>

  <div class="form-group">
    <label class="form-label">{{ t('transfer/moveChildrenToClass') }}</label>
    <ng-select
      class="form-control"
      [items]="(classes$ | async) || []"
      bindLabel="name"
      bindValue="uuid"
      [clearable]="true"
      [placeholder]="t('transfer/withoutClass')"
      [formControl]="classControl"
      [loading]="isLoadingClasses"
      appendTo="body"
    ></ng-select>
  </div>
</div>

<div class="modal-footer d-flex gap-3" *transloco="let t">
  <button type="button" class="btn btn-lg btn-outline-primary m-0" (click)="cancel()">{{ t('transfer/cancel') }}</button>
  <button type="button" class="btn btn-lg btn-primary m-0" (click)="submit()" [disabled]="form.invalid">{{ t('transfer/confirm') }}</button>
</div>
